import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FortinetMetricsService {
    private apiUrl = `${environment.apiHost}/fortinet-metrics`;

    constructor(private http: HttpClient, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {
    }

    async getOfflineEvents(start: number, end: number) {
        return this.http.get(`${this.apiUrl}/offline-events?start=${start}&end=${end}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for offline events timed out!"))
            );
    }

    async getOfflineEventsByStore(start: number, end: number, storeNumber: string) {
        return this.http.get(`${this.apiUrl}/offline-events/store?storeNumber=${storeNumber}&start=${start}&end=${end}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for offline events timed out!"))
            );
    }

    async getNumDevices() {
        return this.http.get(`${this.apiUrl}/total-devices`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for number of devices timed out!"))
            );
    }

    async getOfflineEventsTest() {
        return this.http.get(`${this.apiUrl}/offline-events-test`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for offline events timed out!"))
            );
    }
    async getFortinetHi() {
        return this.http.get(`${this.apiUrl}/hi`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for offline events timed out!"))
            );
    }


}